import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_79whtbwext: FaireCollectionEntity = {
  token: "pbc_79whtbwext",
  type: "collection",
  name: "Organic Cotton Baby Loveys & Cuddle Cloth",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ce6350b24062820c8e0b0bcbc65af6578fdba52080ad689a8a7d5f93df972076.jpeg",
  itemCount: 33,
  description:
    'Organic cotton sweater knit lovey security blanket toys for babies, 14"x14" approx. \nUltra-Soft, lightweight, all-season, breathable, cozy and comfy. \nNon-toxic & natural fabrication for sensitive baby skin, eco-friendly. \nEthically handmade by artisans in India.',
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:18.462Z",
    importedBy: "entity-db-import-collections",
  },
};
